import { ItemsChartModalEditor } from "./ItemsChartModal";

export function TreemapEditor({ block }) {
  return <ItemsChartModalEditor block={block} chartType="treemap" />;
}
